<template>
  <div class="system_container">
    <el-image :src="topImage" class="mb-10 bs-10 br-10 db" style="width: 100%;height: 400px;"></el-image>
    <div v-for="(data,index) in datas" :key="index">
      <el-image :src='data.coverImage' class="mb-10 bs-10 br-10 db" style="width: 100%; height: 600px;"></el-image>
    </div>
    <div class="h-30"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        topImage: '',
        datas: []
      }
    },
    methods: {
      getData() {
        this.$axios.get('/api/service').then(res => {
            //console.log(res.data);
            if (res.data.code == '0') {
              this.datas = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      getTopImage() {
        this.$axios.get('/api/topimage/service').then(res => {
            //console.log(res.data);
            if (res.data.code == '0') {
              this.topImage = res.data.data[0].url;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
    },
    mounted: function() {
      this.getData();
      this.getTopImage();
    }
  }
</script>

<style scoped>
  .system_container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .h-30 {
    height: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/System.vue